/**
 * Логотип «Плюс» — переиспользует SVG из мобильного приложения
 * (apps/mobile/assets/svg/plus_logo.svg). Инлайн-компонент, т.к. в админке
 * нет svgr-плагина для импорта SVG как React-компонента.
 */
export function PlusLogo({ width = 100, title = 'Плюс' }: { width?: number; title?: string }) {
  return (
    <svg
      width={width}
      height={(width * 48) / 128}
      viewBox="0 0 128 48"
      fill="none"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path d="M111.457 0V15.8623H127.379V31.7236H111.457V47.5625H95.5352V31.7236H79.6201V15.8623H95.5352V0H111.457Z" fill="#E96565" />
      <path d="M79.6099 31.7241H63.6875V47.5862H79.6099V31.7241Z" fill="#E96565" />
      <path opacity="0.6" d="M63.6883 15.8618H47.7659V31.7239H63.6883V15.8618Z" fill="#E96565" />
      <path opacity="0.4" d="M47.7661 0H31.8438V15.862H47.7661V0Z" fill="#E96565" />
      <path opacity="0.2" d="M15.9223 15.8618H0V31.7239H15.9223V15.8618Z" fill="#E96565" />
      <path opacity="0.8" d="M79.6099 0H63.6875V15.862H79.6099V0Z" fill="#E96565" />
    </svg>
  );
}
